var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.62v11.241c0 .538-.11 1.07-.323 1.568a4.085 4.085 0 0 1-.921 1.329c-.395.38-.864.682-1.38.888a4.387 4.387 0 0 1-1.628.31H9.252a4.336 4.336 0 0 1-3.007-1.199A4.02 4.02 0 0 1 5 33.861V15.095A4.02 4.02 0 0 1 6.245 12.2 4.336 4.336 0 0 1 9.252 11H29",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22.806v9.842c0 .624-.262 1.222-.729 1.663-.466.441-1.1.689-1.76.689H10.486c-.327 0-.65-.06-.952-.18a2.498 2.498 0 0 1-.806-.509 2.344 2.344 0 0 1-.539-.763 2.237 2.237 0 0 1-.188-.9v-16.33a2.284 2.284 0 0 1 .738-1.642A2.557 2.557 0 0 1 10.485 14h18.21",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.182 22.304H45L29 11l.348 7.599c0 .98.446 1.918 1.24 2.61.794.693 1.871 1.082 2.994 1.082h8.585",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateInspection);
export default __webpack_public_path__ + "static/media/state-inspection.554dba3d7c7d4d2228003cc1a9d89c57.svg";
export { ForwardRef as ReactComponent };